module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/svg--illos-pro-eb85ee89.svg";